import React, { useRef, useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    FieldWrappers,
    ModalHeader,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { MdClose } from "react-icons/md";
import { alertType, assetAssignTo } from "../../Config";
import SelectOptionModal from "../SelectOptionModal";
import { FaPlus } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import moment from "moment";

const AddAlertModal = ({
    setAddAlertDetail,
    addAlertDetailMutate,
    addAlertDetailLoading,
    selectedData,
    editAlertData
}) => {
    const formikRef = useRef(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [dateCalendarOpen, setDateCalendarOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // const initialValues = {
    //     type: "",
    //     date: "",
    //     assetId: selectedData?.id,
    // };
    const getInitialValues = () => {
        if (editAlertData) {
            return {
                type: editAlertData.type || "",
                date: editAlertData.value || "",
                alertId: editAlertData.id || null,
                assetId: selectedData?.id,
            };
        }
        return {
            type: "",
            date: "",
            alertId: null,
            assetId: selectedData?.id,
        };
    };

    const initialValues = getInitialValues();

    const assignToOptions = assetAssignTo.map(role => ({
        label: role.label,
        value: role.value,
    }));

    const validationSchema = Yup.object({
        type: Yup.string().required("Select Alert Type"),
        date: Yup.date().required("Select Date"),
    });

    const handleSubmit = (values) => {
        addAlertDetailMutate({
            assetId: selectedData?.id,
            type: Number(values.type),
            value: values.date,
        });
    };
    const isEditing = !!editAlertData;
    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">   {editAlertData ? "Edit Alert" : "Add Alert"}</h1>
                <CloseButton onClick={() => setAddAlertDetail(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </ModalHeader>
            <Content>
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                >
                    {({ values, setFieldValue, errors, touched }) => {
                        const getAssignLabel = () => {
                            const selectedAssignTo = alertType.find(role => role.value === values?.type);
                            return selectedAssignTo ? selectedAssignTo.label : "Select type";
                        };

                        const handleAssignToSelect = (selectedValue) => {
                            setFieldValue("type", selectedValue);
                        };

                        return (
                            <Form>
                                <ScrollableContent>
                                    <Wrapper>
                                        {/* Alert Type Selection */}
                                        <InputGroup>
                                            <Label htmlFor="type">Type *</Label>
                                            {isEditing ? (
                                                // Show as disabled text field when editing
                                                <FieldWrappers className="bg-gray-100 cursor-not-allowed">
                                                    <Field
                                                        type="text"
                                                        name="type"
                                                        id="type"
                                                        autoComplete="off"
                                                        disabled
                                                        value={getAssignLabel()}
                                                        className="w-full border-none outline-none bg-transparent cursor-not-allowed text-gray-600"
                                                    />
                                                    {/* <IconWrapper className="opacity-50">
                                                        <FaPlus className="w-3 h-3" />
                                                    </IconWrapper> */}
                                                </FieldWrappers>
                                            ) : (
                                                // Clickable field for adding new alert
                                                <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                    <Field
                                                        type="text"
                                                        name="type"
                                                        id="type"
                                                        autoComplete="off"
                                                        readOnly
                                                        value={getAssignLabel()}
                                                        className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                    />
                                                    <IconWrapper>
                                                        <FaPlus className="w-3 h-3" />
                                                    </IconWrapper>
                                                </FieldWrappers>
                                            )}
                                            {errors.type && touched.type && (
                                                <ErrorText>{errors.type}</ErrorText>
                                            )}
                                        </InputGroup>
                                        {/* <InputGroup>
                                            <Label htmlFor="type">Type *</Label>
                                            <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="type"
                                                    id="type"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getAssignLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                />
                                                <IconWrapper>
                                                    <FaPlus className="w-3 h-3" />
                                                </IconWrapper>
                                            </FieldWrappers>
                                            {errors.type && touched.type && (
                                                <ErrorText>{errors.type}</ErrorText>
                                            )}
                                        </InputGroup> */}

                                        {/* Date Input with DatePicker */}
                                        <InputGroup>
                                            <Label htmlFor="date">Expiry Date *</Label>
                                            <FieldWrappers>
                                                <DatePicker
                                                    selected={values.date ? moment(values.date, "YYYY-MM-DD").toDate() : null}
                                                    onChange={(date) => {
                                                        setFieldValue("date", moment(date).format("YYYY-MM-DD"));
                                                        setDateCalendarOpen(false);
                                                    }}
                                                    showYearDropdown
                                                    yearDropdownItemNumber={70}
                                                    scrollableYearDropdown
                                                    onClickOutside={() => setDateCalendarOpen(false)}
                                                    onSelect={() => setDateCalendarOpen(false)}
                                                    open={dateCalendarOpen}
                                                    onInputClick={() => setDateCalendarOpen(true)}
                                                    dateFormat="yyyy-MM-dd"
                                                    className="cursor-pointer items-center w-full"
                                                    placeholderText="Select date"
                                                    showIcon
                                                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                    showPopperArrow={false}
                                                    minDate={new Date()}
                                                    onFocus={(e) => e.target.blur()}
                                                    wrapperClassName="w-full"
                                                    name="date"
                                                    id="date"
                                                    autoComplete="off"
                                                    portalId="root-portal"
                                                    popperClassName="react-datepicker-popper"
                                                />
                                            </FieldWrappers>
                                            {errors.date && touched.date && (
                                                <ErrorText>{errors.date}</ErrorText>
                                            )}
                                        </InputGroup>
                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn
                                        type="button"
                                        onClick={() => setAddAlertDetail(false)}
                                    >
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={addAlertDetailLoading}>
                                        {addAlertDetailLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>

                                <SelectOptionModal
                                    isOpen={isAssignModalOpen}
                                    onClose={() => setIsAssignModalOpen(false)}
                                    title="Select Alert Type"
                                    options={alertType.map(role => ({
                                        label: role.label,
                                        value: role.value,
                                    }))}
                                    selectedValue={values.type}
                                    onSelect={handleAssignToSelect}
                                    searchPlaceholder="Search alert type..."
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </Content>
        </Container>
    );
};

const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;
const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;

export default AddAlertModal;